import { Http } from '../axios/interceptors'


export const allInstances = async (param) => Http('GET', `/InstanciasEvolution/GetByCompany?`, param)

export const getInstanceByCompany = async (param) => Http('GET', `/InstanciasEvolution/GetGuidCompany?`, param)

export const getIntance = async (param) => Http('GET', `/InstanciasEvolution/Get?`, param)

export const createOrEditIntance = async (body, id = null) => (id ? Http('PUT', `/InstanciasEvolution/Update`, null, body) : Http('POST', '/InstanciasEvolution/Create', null, body))

export const deleteInstance = async idInstance => Http('DELETE', `/InstanciasEvolution/Delete?id=${idInstance}`)


